module.exports = __webpack_public_path__ + "static/media/icon-letter.24da4cc3.svg";